<template>
    <div class="staff-management">
      <!-- <h2>职工管理</h2> -->
      
      <!-- 操作按钮区 -->
      <div class="operation-area">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加职工</el-button>
        <el-input
          v-model="searchKeyword"
          placeholder="请输入姓名或手机号"
          style="width: 250px; margin-left: 10px"
          prefix-icon="el-icon-search"
          @input="handleSearch"
          clearable
        ></el-input>
        <el-select v-model="positionFilter" placeholder="岗位筛选" style="width: 140px; margin-left: 10px" clearable>
          <el-option label="医生" value="医生"></el-option>
          <el-option label="项目管理员" value="项目管理员"></el-option>
          <el-option label="护士" value="护士"></el-option>
          <el-option label="个管师" value="个管师"></el-option>
        </el-select>
        <el-select v-model="departmentFilter" placeholder="科室筛选" style="width: 140px; margin-left: 10px" clearable>
          <el-option v-for="dept in departments" :key="dept.id" :label="dept.name" :value="dept.id"></el-option>
        </el-select>
      </div>
      
      <!-- 职工表格 -->
      <el-table
        :data="filteredStaffList"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="姓名" width="100">
          <template slot-scope="scope">
            <div class="staff-name">
              <el-avatar :size="30" :src="scope.row.avatar"></el-avatar>
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
        <el-table-column prop="staffId" label="工号" width="100"></el-table-column>
        <el-table-column prop="position" label="岗位" width="120">
          <template slot-scope="scope">
            {{ scope.row.position }}
          </template>
        </el-table-column>
        <el-table-column prop="roles" label="角色" width="200">
          <template slot-scope="scope">
            <el-tag v-for="role in scope.row.roles" :key="role" size="small" style="margin-right: 5px">{{ role }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="department" label="所属科室" width="120"></el-table-column>
        <el-table-column prop="specialty" label="擅长疾病" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="introduction" label="个人简介" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑职工对话框 -->
      <el-dialog 
        :title="dialogTitle" 
        :visible.sync="dialogVisible" 
        width="700px"
        :close-on-click-modal="false"
      >
        <el-form :model="staffForm" :rules="staffRules" ref="staffForm" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="职工姓名" prop="name">
                <el-input v-model="staffForm.name" placeholder="请输入职工姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="staffForm.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工号" prop="staffId">
                <el-input v-model="staffForm.staffId" placeholder="请输入工号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="岗位" prop="position">
                <el-select v-model="staffForm.position" placeholder="请选择岗位">
                  <el-option label="医生" value="医生"></el-option>
                  <el-option label="项目管理员" value="项目管理员"></el-option>
                  <el-option label="护士" value="护士"></el-option>
                  <el-option label="个管师" value="个管师"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="证件类型" prop="idType">
                <el-radio-group v-model="staffForm.idType">
                  <el-radio label="身份证">身份证</el-radio>
                  <el-radio label="医生证">医生证</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="证件号码" prop="idNumber">
                <el-input v-model="staffForm.idNumber" placeholder="请输入证件号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属科室" prop="departmentId">
                <el-select v-model="staffForm.departmentId" placeholder="请选择科室">
                  <el-option v-for="dept in departments" :key="dept.id" :label="dept.name" :value="dept.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="学历" prop="education">
                <el-select v-model="staffForm.education" placeholder="请选择学历">
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="硕士" value="硕士"></el-option>
                  <el-option label="博士" value="博士"></el-option>
                  <el-option label="博士后" value="博士后"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="角色" prop="roles">
            <el-checkbox-group v-model="staffForm.roles">
              <el-checkbox label="医生角色">医生角色</el-checkbox>
              <el-checkbox label="个管师">个管师</el-checkbox>
              <el-checkbox label="管理员">管理员</el-checkbox>
              <el-checkbox label="项目管理员">项目管理员</el-checkbox>
              <el-checkbox label="护士角色">护士角色</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="头像上传" prop="avatar">
                <el-upload
                  class="avatar-uploader"
                  action="/api/upload"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="staffForm.avatar" :src="staffForm.avatar" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="签名上传" prop="signature">
                <el-upload
                  class="signature-uploader"
                  action="/api/upload"
                  :show-file-list="false"
                  :on-success="handleSignatureSuccess"
                  :before-upload="beforeSignatureUpload"
                >
                  <img v-if="staffForm.signature" :src="staffForm.signature" class="signature">
                  <i v-else class="el-icon-plus signature-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-form-item label="擅长疾病" prop="specialty">
            <el-input v-model="staffForm.specialty" placeholder="请输入擅长疾病，多个疾病用逗号分隔"></el-input>
          </el-form-item>
          
          <el-form-item label="个人简介" prop="introduction">
            <el-input type="textarea" v-model="staffForm.introduction" :rows="4" placeholder="请输入个人简介"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'staff-management',
    data() {
      // 手机号验证规则
      const validatePhone = (rule, value, callback) => {
        if (value && !/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      };
      
      return {
        // 表格数据
        staffList: [
          {
            id: 1,
            name: '许昊然',
            phone: '13812345678',
            staffId: 'DR001',
            position: '医生',
            roles: ['医生角色', '项目管理员'],
            department: '内科',
            departmentId: 1,
            specialty: '高血压, 糖尿病, 心血管疾病',
            introduction: '许昊然医生，主任医师，从事内科临床工作20年，擅长各种常见内科疾病的诊断与治疗',
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            signature: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
            idType: '医生证',
            idNumber: '10098765432',
            education: '博士'
          },
          {
            id: 2,
            name: '苏雅婷',
            phone: '13898765432',
            staffId: 'DR002',
            position: '医生',
            roles: ['医生角色'],
            department: '外科',
            departmentId: 2,
            specialty: '骨折, 创伤, 关节疾病',
            introduction: '苏雅婷医生，副主任医师，从事外科临床工作15年，擅长骨科疾病的诊断与手术治疗',
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            signature: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
            idType: '医生证',
            idNumber: '10098765431',
            education: '硕士'
          },
          {
            id: 3,
            name: '林书辰',
            phone: '13756789012',
            staffId: 'NR001',
            position: '护士',
            roles: ['护士角色'],
            department: '内科',
            departmentId: 1,
            specialty: '基础护理, 静脉注射, 伤口护理',
            introduction: '林书辰，主管护师，从事护理工作10年，具有丰富的临床护理经验',
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            signature: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
            idType: '身份证',
            idNumber: '330101199001011234',
            education: '本科'
          },
          {
            id: 4,
            name: '程若曦',
            phone: '13612345678',
            staffId: 'PM001',
            position: '项目管理员',
            roles: ['项目管理员', '管理员'],
            department: '行政部',
            departmentId: 5,
            specialty: '医疗信息系统, 项目管理, 质量控制',
            introduction: '程若曦，高级项目经理，负责医院信息化建设和医疗随访项目管理工作',
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            signature: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
            idType: '身份证',
            idNumber: '330101198801015678',
            education: '硕士'
          },
          {
            id: 5,
            name: '郭子轩',
            phone: '13509876543',
            staffId: 'CM001',
            position: '个管师',
            roles: ['个管师'],
            department: '随访中心',
            departmentId: 6,
            specialty: '慢病管理, 健康教育, 随访管理',
            introduction: '郭子轩，高级个案管理师，负责患者随访和慢病管理工作，对糖尿病和高血压患者的健康管理有丰富经验',
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            signature: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
            idType: '身份证',
            idNumber: '330101199201018765',
            education: '本科'
          }
        ],
        // 科室数据
        departments: [
          { id: 1, name: '内科' },
          { id: 2, name: '外科' },
          { id: 3, name: '妇产科' },
          { id: 4, name: '儿科' },
          { id: 5, name: '行政部' },
          { id: 6, name: '随访中心' }
        ],
        // 表格加载状态
        loading: false,
        // 搜索关键词
        searchKeyword: '',
        // 岗位筛选
        positionFilter: '',
        // 科室筛选
        departmentFilter: '',
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        totalCount: 5,
        
        // 弹窗相关
        dialogVisible: false,
        dialogTitle: '添加职工',
        dialogType: 'add', // 'add' 或 'edit'
        staffForm: {
          name: '',
          phone: '',
          staffId: '',
          position: '',
          roles: [],
          departmentId: '',
          specialty: '',
          introduction: '',
          avatar: '',
          signature: '',
          idType: '身份证',
          idNumber: '',
          education: ''
        },
        
        // 表单验证规则
        staffRules: {
          name: [
            { required: true, message: '请输入职工姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          staffId: [
            { required: true, message: '请输入工号', trigger: 'blur' }
          ],
          position: [
            { required: true, message: '请选择岗位', trigger: 'change' }
          ],
          departmentId: [
            { required: true, message: '请选择所属科室', trigger: 'change' }
          ],
          roles: [
            { type: 'array', required: true, message: '请至少选择一个角色', trigger: 'change' }
          ],
          idType: [
            { required: true, message: '请选择证件类型', trigger: 'change' }
          ],
          idNumber: [
            { required: true, message: '请输入证件号码', trigger: 'blur' }
          ],
          education: [
            { required: true, message: '请选择学历', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      // 过滤后的职工列表
      filteredStaffList() {
        let result = this.staffList;
        
        // 关键词过滤
        if (this.searchKeyword) {
          const keyword = this.searchKeyword.toLowerCase();
          result = result.filter(staff => 
            staff.name.toLowerCase().includes(keyword) || 
            staff.phone.includes(keyword)
          );
        }
        
        // 岗位筛选
        if (this.positionFilter) {
          result = result.filter(staff => staff.position === this.positionFilter);
        }
        
        // 科室筛选
        if (this.departmentFilter) {
          result = result.filter(staff => staff.departmentId === this.departmentFilter);
        }
        
        return result;
      }
    },
    methods: {
      // 搜索处理
      handleSearch() {
        this.currentPage = 1;
        // 实际应用中可能需要调用API
      },
      
      // 添加职工
      handleAdd() {
        this.dialogType = 'add';
        this.dialogTitle = '添加职工';
        this.staffForm = {
          name: '',
          phone: '',
          staffId: '',
          position: '',
          roles: [],
          departmentId: '',
          specialty: '',
          introduction: '',
          avatar: '',
          signature: '',
          idType: '身份证',
          idNumber: '',
          education: ''
        };
        this.dialogVisible = true;
        
        // 确保表单验证信息重置
        if (this.$refs.staffForm) {
          this.$refs.staffForm.resetFields();
        }
      },
      
      // 编辑职工
      handleEdit(row) {
        this.dialogType = 'edit';
        this.dialogTitle = '编辑职工';
        
        // 拷贝数据，避免直接修改表格数据
        this.staffForm = { ...row };
        this.dialogVisible = true;
      },
      
      // 删除职工
      handleDelete(row) {
        this.$confirm('确定要删除该职工信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          const index = this.staffList.findIndex(item => item.id === row.id);
          if (index !== -1) {
            this.staffList.splice(index, 1);
            this.totalCount--;
            this.$message.success('删除成功');
          }
        }).catch(() => {
          // 取消删除
        });
      },
      
      // 提交表单
      submitForm() {
        this.$refs.staffForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              if (this.dialogType === 'add') {
                // 模拟添加操作
                const newStaff = {
                  ...this.staffForm,
                  id: this.staffList.length + 1,
                  // 根据departmentId获取部门名称
                  department: this.departments.find(d => d.id === this.staffForm.departmentId)?.name || '未知科室'
                };
                this.staffList.push(newStaff);
                this.totalCount++;
                this.$message.success('添加成功');
              } else {
                // 模拟编辑操作
                const index = this.staffList.findIndex(item => item.id === this.staffForm.id);
                if (index !== -1) {
                  // 更新department字段
                  this.staffForm.department = this.departments.find(d => d.id === this.staffForm.departmentId)?.name || '未知科室';
                  this.staffList[index] = { ...this.staffForm };
                  this.$message.success('编辑成功');
                }
              }
              this.loading = false;
              this.dialogVisible = false;
            }, 500);
          } else {
            return false;
          }
        });
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 头像上传相关方法
      handleAvatarSuccess(res, file) {
        // 模拟上传成功，实际应用中应使用服务器返回的URL
        this.staffForm.avatar = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return (isJPG || isPNG) && isLt2M;
      },
      
      // 签名上传相关方法
      handleSignatureSuccess(res, file) {
        // 模拟上传成功
        this.staffForm.signature = URL.createObjectURL(file.raw);
      },
      beforeSignatureUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
  
        if (!isJPG && !isPNG) {
          this.$message.error('上传签名图片只能是 JPG 或 PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传签名图片大小不能超过 2MB!');
        }
        return (isJPG || isPNG) && isLt2M;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .staff-management {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .operation-area {
      display: flex;
      margin-bottom: 15px;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .staff-name {
      display: flex;
      align-items: center;
    }
    
    .avatar-uploader,
    .signature-uploader {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 178px;
      height: 100px;
      
      &:hover {
        border-color: #409EFF;
      }
      
      .avatar-uploader-icon,
      .signature-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      
      .avatar,
      .signature {
        width: 178px;
        height: 100px;
        display: block;
        object-fit: cover;
      }
    }
  }
  </style>